import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { NavigationButton } from "../NavigationButton";

import {
  clearGrades,
  fetchAllGrades,
  fetchAllSubjectsGrades,
  fetchAverageGrade,
} from "../../../store/gradeSlice";
import {
  clearReportCards,
  fetchAllReportCards,
  fetchAllSemesters,
} from "../../../store/reportCardSlice";
import {
  clearWeekData,
  fetchWeekDay,
  fetchWeekName,
  fetchWeekNumber,
} from "../../../store/weekDataSlice";
import {
  clearSchedule,
  fetchStudentsSchedule,
} from "../../../store/scheduleSlice";
import {
  clearAttendances,
  fetchAttendances,
} from "../../../store/attendanceSlice";
import { persistor } from "../../../store";
import { clearStudentInfo } from "../../../store/studentSlice";
import { logoutUser } from "../../../store/authSlice";
import { fetchAbsences } from "../../../store/absencesSlice";
import { setMenuCondition } from "../../../store/extraSlice";
import { clearNotifications } from "../../../store/notificationSlice";

import userIcon from "../../../assets/images/buttonIcons/User.svg";
import calendarIcon from "../../../assets/images/buttonIcons/Calendar.svg";
import statisticIcon from "../../../assets/images/buttonIcons/Chart.svg";
import attendanceIcon from "../../../assets/images/buttonIcons/Component.svg";
import debtsIcon from "../../../assets/images/buttonIcons/Receipt.svg";
import userManualIcon from "../../../assets/images/buttonIcons/InfoSquare.svg";
import logoutIcon from "../../../assets/images/buttonIcons/Logout.svg";

import "../style.css";

export const StudentNavButtons = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const studentGroup = useSelector((state) => state.student.studentInfo);
  const userToken = useSelector((state) => state.auth.userToken);

  const storedToken = Cookies.get("userToken");
  let parsedToken = null;
  if (storedToken) {
    try {
      parsedToken = JSON.parse(storedToken);
    } catch (error) {
      console.error("Error parsing stored token:", error);
    }
  }

  const isTokenExpired = (token) => {
    const expiresAtDate = new Date(token.expires_at);
    const expiresAtSeconds = expiresAtDate.getTime() / 1000;
    const currentTime = Date.now() / 1000;

    return expiresAtSeconds < currentTime;
  };

  useEffect(() => {
    if (!storedToken || isTokenExpired(parsedToken)) {
      handleLogout();
      navigate("/login");
    }
  }, [storedToken, navigate, dispatch]);

  const handleLogout = () => {
    dispatch(logoutUser());
    dispatch(clearStudentInfo());
    dispatch(clearSchedule());
    dispatch(clearWeekData());
    dispatch(clearGrades());
    dispatch(clearReportCards());
    dispatch(clearAttendances());
    dispatch(clearNotifications());
    persistor.purge();
    navigate("/login");
  };
  const handleProfileInfo = () => {
    dispatch(setMenuCondition(false));
  };

  const handleScheduleInfo = () => {
    // dispatch(fetchStudentsSchedule(studentGroup.group.name));
    // dispatch(fetchWeekDay());
    // dispatch(fetchWeekNumber());
    // dispatch(fetchWeekName());
    dispatch(setMenuCondition(false));
  };

  const handleGradesInfo = () => {
    dispatch(fetchAllGrades(userToken));
    dispatch(fetchAverageGrade(userToken));
    dispatch(fetchAllSubjectsGrades(userToken));
    dispatch(setMenuCondition(false));
  };

  const handleReportCardsInfo = () => {
    // dispatch(fetchAllReportCards(userToken));
    // dispatch(fetchAllSemesters(userToken));
    // dispatch(fetchAverageSemesterGrade({ token: userToken, semester: 0 }));
    dispatch(setMenuCondition(false));
  };

  const handleAbsencesInfo = () => {
    // dispatch(fetchAbsences(userToken));
    dispatch(setMenuCondition(false));
  };

  const handleAttendanceInfo = () => {
    dispatch(fetchAttendances(userToken));
    dispatch(setMenuCondition(false));
  };

  const handleManualInfo = () => {
    dispatch(setMenuCondition(false));
  };

  let schedule = `/schedule/${studentGroup && studentGroup.group.id}/${
    studentGroup && studentGroup.group.name
  }/${
    studentGroup && studentGroup.group.facultyType === "CORRESPONDENCE"
      ? true
      : false
  }`;

  return (
    <>
      <div className="sidebar">
        <NavigationButton
          to="/"
          clickFunction={handleProfileInfo}
          icon={userIcon}
          text="Мой профиль"
          isActive={location.pathname === "/"}
        />
        <NavigationButton
          to={schedule}
          clickFunction={handleScheduleInfo}
          icon={calendarIcon}
          text="Расписание"
          isActive={decodeURI(location.pathname) === schedule}
        />
        {/* <NavigationButton
          to="/statistic"
          clickFunction={handleGradesInfo}
          icon={statisticIcon}
          text="Статистика"
          isActive={location.pathname === "/statistic"}
        /> */}
        <NavigationButton
          to="/reportCard"
          clickFunction={handleReportCardsInfo}
          icon={statisticIcon}
          text="Электронная зачетная книжка"
          isActive={location.pathname === "/reportCard"}
        />
        {/* <NavigationButton
          to="/attendance"
          clickFunction={handleAttendanceInfo}
          icon={attendanceIcon}
          text="Посещения занятий"
          isActive={location.pathname === "/attendance"}
        /> */}
        <NavigationButton
          to="/debts"
          clickFunction={handleAbsencesInfo}
          icon={debtsIcon}
          text="Пропуски занятий"
          isActive={location.pathname === "/debts"}
        />
        <div className="dividing_line"></div>
        <NavigationButton
          to="/manual"
          clickFunction={handleManualInfo}
          icon={userManualIcon}
          text="Руководство пользователя"
          isActive={location.pathname === "/manual"}
        />
        <NavigationButton
          to="/login"
          clickFunction={handleLogout}
          icon={logoutIcon}
          text="Выйти из профиля"
        />
      </div>
    </>
  );
};
